<template>
	<div class="container__crud">
		<div
			class="container__crudactions"
			style="flex-flow: row nowrap"
		>
			<div class="container__crudactions__form">
				<label class="container__crudactions__form__label__select__level">{{
					$t('nivelExportacaoProjecoes')
				}}</label>
				<Switcher
					v-model="isPlantioLevel"
					style="margin-top: 0.5rem"
					:left-label="`${$t('forestStratification')} / ${$t('forestInventory')}`"
					:label="$t('plantation')"
				/>

				<div class="container__crudactions__form__select">
					<MultiSelect
						v-model="inventariosFlorestaisEscolhidos"
						style="padding-right: 20px; width: 50%"
						:label="`${$t('forestStratification')} / ${$t('forestInventory')}`"
						:options="estratosFlorestaisEInventarios"
					/>

					<MultiSelect
						v-show="isPlantioLevel"
						v-model="plantiosEscolhidos"
						style="padding-right: 20px; width: 50%"
						:label="$t('plantation')"
						:options="plantios"
					/>
				</div>
			</div>
		</div>

		<Button
			style="margin-left: auto !important; margin-right: 20px !important; margin-top: 1rem"
			:label="$t('export')"
			color="trv-default"
			semantic-class="tiny"
			:disabled="botaoDesabilitado"
			width-auto
			@click="exportar"
		/>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'
import Switcher from '../../../components/Switcher/Switcher'

import {
	getDropdownExportacaoProjecoes,
	exportarANivelDeEstratoEInventarioFlorestal,
	exportarANivelDePlantio,
} from '../../../services/requests/PrognoseRequests'

import { stringToExportCSV } from '../../../utils/csvHellpers'

export default {
	components: {
		Button,
		MultiSelect,
		Switcher,
	},
	data() {
		return {
			dropdown: [],
			/**
			 * Inventários selecionados para recuperar as projecoes
			 */
			inventariosFlorestaisEscolhidos: [],

			/**
			 * Plantios selecionados para recuperar as projecoes
			 */
			plantiosEscolhidos: [],
			isPlantioLevel: false,
		}
	},
	computed: {
		/**
		 * Dropdown de inventarios florestais
		 */
		estratosFlorestaisEInventarios() {
			return this.dropdown.map((m) => {
				return Object.assign(m, {
					label: `EF-${m.estratoFlorestal} / IF-${m.inventarioFlorestal}`,
					value: m.prognoseAplicadaId,
				})
			})
		},

		/**
		 * Dropdown de estratos florestais
		 */
		plantios() {
			const opcoesPlantios = []
			const prognoseAplicadaSelecionada = this.dropdown.filter((f) =>
				this.inventariosFlorestaisEscolhidos.includes(f.prognoseAplicadaId),
			)
			prognoseAplicadaSelecionada.forEach((prognoseAplicada) => {
				const plantiosAtuais = prognoseAplicada.plantios.map((plantio) => ({
					...plantio,
					inventarioFlorestal: prognoseAplicada.inventarioFlorestal,
					inventarioFlorestalId: prognoseAplicada.inventarioFlorestalId,
				}))
				opcoesPlantios.push(...plantiosAtuais)
			})
			return opcoesPlantios.map((m) => {
				return {
					label: `Inventário: ${m.inventarioFlorestal} / Plantio: ${m.plantioCodigo}`,
					value: m.prognosePlantioId,
					inventarioFlorestalId: m.inventarioFlorestalId,
					plantioId: m.plantioId,
				}
			})
		},
		/**
		 * Controla se deve habilitar ou desabilitar o botao
		 */
		botaoDesabilitado() {
			if (!this.isPlantioLevel && this.inventariosFlorestaisEscolhidos.length > 0) {
				return false
			} else if (this.plantiosEscolhidos.length > 0) {
				return false
			}
			return true
		},

		/**
		 * Monta o nome do arquivo CSV que deve ser exportado
		 */
		pegaDataAtual() {
			const dataAtual = new Date()
			const dia = ('0' + dataAtual.getDate()).slice(-2)
			const mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
			const ano = dataAtual.getFullYear().toString().substr(-2)
			const hora = ('0' + dataAtual.getHours()).slice(-2)
			const minuto = ('0' + dataAtual.getMinutes()).slice(-2)
			const segundo = ('0' + dataAtual.getSeconds()).slice(-2)
			return `_${dia}_${mes}_${ano}_${hora}_${minuto}_${segundo}`
		},
	},
	watch: {
		/**
		 * Sempre que um inventario florestal for trocado verifica se existem plantios que foram selecionados
		 */
		inventariosFlorestaisEscolhidos(newValue) {
			var prognoseAplicadaComPlantio = this.dropdown.map((m) => {
				return {
					prognoseAplicadaId: m.prognoseAplicadaId,
					plantios: m.plantios.map((m) => m.prognosePlantioId),
				}
			})

			var plantiosParaSeremRemovidos = prognoseAplicadaComPlantio
				.filter((id) => !newValue.includes(id.prognoseAplicadaId))
				.map((m) => m.plantios)
				.reduce((acumulador, array) => acumulador.concat(array), [])

			this.plantiosEscolhidos = this.plantiosEscolhidos.filter(
				(plantiosEscolhidos) => !plantiosParaSeremRemovidos.includes(plantiosEscolhidos),
			)
		},
	},
	async created() {
		/**
		 * Busca os dados para preencher os dropdowns
		 */
		const response = await getDropdownExportacaoProjecoes()
		console.log('🚀 ~ file: PrognoseVinculada.vue ~ line 48 ~ created ~ response', response)
		this.dropdown = response.data
	},
	methods: {
		/**
		 * Metodo que exporta o CSV
		 */
		async exportar() {
			var fileName = ''
			if (this.isPlantioLevel) {
				const payload = this.plantiosEscolhidos.map((prognosePlantioId) => {
					const plantio = this.plantios.find((p) => p.value === prognosePlantioId)
					return {
						prognosePlantioId,
						inventarioFlorestalId: plantio?.inventarioFlorestalId,
						plantioId: plantio?.plantioId,
					}
				})
				exportarANivelDePlantio(payload).then((result) => {
					//projecoes
					var projecoes = result.data
					if (this.plantiosEscolhidos.length == 1) {
						//nome caso tenha apenas um plantio
						fileName =
							'prognose_inventario_' +
							result.data[0].inventarioFlorestal.trim().replace(/[- ]/g, '_').replace(/__+/g, '_') +
							'_plantio_' +
							result.data[0].plantio +
							this.pegaDataAtual
					} else {
						//nome caso tenha mais de um plantio
						fileName = 'prognose_inventario' + this.pegaDataAtual
					}
					// Header
					var csv =
						'Fazenda;Estrato Florestal;Inventário Florestal;Plantio;Data do Plantio;Área do Plantio;Material Genético;Variável de Interesse;Idade(meses);Idade(anos);Data Projeção;Tipo;ICM;IMM;ITC;Variável Biométrica\n'

					// Linhas
					projecoes.forEach((projecao) => {
						csv += `${projecao.fazenda};${projecao.estrato};${projecao.inventarioFlorestal};${projecao.plantio};${projecao.dataPlantio ? projecao.dataPlantio.substring(8, 10) + '-' + projecao.dataPlantio.substring(5, 7) + '-' + projecao.dataPlantio.substring(0, 4) : ''};${projecao.area};${projecao.mtge};${projecao.variavelDeInteresse};${(projecao.idade ?? '').toString().replace('.', ',')};${(projecao.idadeAnos ?? '').toString().replace('.', ',')};${projecao.dataProjecao ? projecao.dataProjecao.substring(8, 10) + '-' + projecao.dataProjecao.substring(5, 7) + '-' + projecao.dataProjecao.substring(0, 4) : ''};${projecao.tipo ?? ''};${(projecao.icm ?? '').toString().replace('.', ',')};${(projecao.imm ?? '').toString().replace('.', ',')};${projecao.itc ?? ''};${(projecao.variavelBiometrica ?? '').toString().replace('.', ',')}\n`
					})

					stringToExportCSV(fileName, csv)
				})
			} else {
				exportarANivelDeEstratoEInventarioFlorestal(this.inventariosFlorestaisEscolhidos).then(
					(result) => {
						//projecoes
						var projecoes = result.data

						if (this.inventariosFlorestaisEscolhidos.length == 1) {
							//nome caso tenha apenas um inventario
							fileName =
								'prognose_inventario_EF_' +
								result.data[0].estratoFlorestal.trim().replace(/[- ]/g, '_').replace(/__+/g, '_') +
								'_IF_' +
								result.data[0].inventarioFlorestal
									.trim()
									.replace(/[- ]/g, '_')
									.replace(/__+/g, '_') +
								this.pegaDataAtual
						} else {
							//nome caso tenha mais de um inventario
							fileName = 'prognose_inventario' + this.pegaDataAtual
						}

						// Header
						var csv =
							'Fazenda;Estrato Florestal;Inventário Florestal;Variável de Interesse;Idade(meses);Idade(anos);Data Projeção;Tipo;ICM;IMM;ITC;Variável Biométrica\n'

						// Linhas
						projecoes.forEach((projecao) => {
							csv += `${projecao.fazenda};${projecao.estratoFlorestal};${projecao.inventarioFlorestal};${projecao.variavelDeInteresse};${(projecao.idadeEmMeses ?? '').toString().replace('.', ',')};${(projecao.idadeAnos ?? '').toString().replace('.', ',')};${projecao.dataProjecao ? projecao.dataProjecao.substring(8, 10) + '-' + projecao.dataProjecao.substring(5, 7) + '-' + projecao.dataProjecao.substring(0, 4) : ''};${projecao.tipo ?? ''};${(projecao.icm ?? '').toString().replace('.', ',')};${(projecao.imm ?? '').toString().replace('.', ',')};${projecao.itc ?? ''};${(projecao.variavelBiometrica ?? '').toString().replace('.', ',')}\n`
						})

						stringToExportCSV(fileName, csv)
					},
				)
			}
		},
	},
}
</script>

<style>
.container__crudactions__form {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.container__crudactions__form__select {
	display: flex;
	flex-direction: row;
	margin-top: 2rem;
}

.container__crudactions__form__label__select__level {
	font-size: 0.8rem;
	font-weight: 400;
	color: var(--color-navy-blue);
}
</style>

<style scoped src="../../../css/crud.css"></style>
